import Modal from './modal'

interface NotificationsDeniedModalProps {
	open: boolean
	onOpenChange: (open: boolean) => void
}

export default function NotificationsDeniedModal(props: NotificationsDeniedModalProps) {
	return (
		<Modal
			open={props.open}
			onOpenChange={props.onOpenChange}
		>
			<div className="space-y-6">
				<h1 className="scroll-m-20 text-4xl font-bold tracking-tight">Enable Notifications in Browser Settings</h1>

				<p>Notifications seem to be blocked in your browser. To enable them, update your browser settings:</p>
				<div>
					<h3 className="font-semibold mb-2 text-base">iOS (Safari PWA)</h3>
					<ol className="list-decimal list-inside space-y-1 text-sm">
						<li>Go to iPhone Settings → hangaround.live</li>
						<li>Enable "Notifications"</li>
						<li>Return to the app and refresh</li>
					</ol>
				</div>

				<div>
					<h3 className="font-semibold mb-2 text-base">Android (Chrome)</h3>
					<ol className="list-decimal list-inside space-y-1 text-sm">
						<li>Tap the menu (three dots) → Settings</li>
						<li>Tap "Site settings" → "Notifications"</li>
						<li>Find hangaround.live and select "Allow"</li>
						<li>Return to the app and refresh</li>
					</ol>
				</div>

				<div>
					<h3 className="font-semibold mb-2 text-base">Desktop (Chrome/Edge)</h3>
					<ol className="list-decimal list-inside space-y-1 text-sm">
						<li>Click the lock icon in the address bar</li>
						<li>Find "Notifications" and change to "Allow"</li>
						<li>Refresh the page</li>
					</ol>
				</div>

				<div>
					<h3 className="font-semibold mb-2 text-base">Desktop (Safari)</h3>
					<ol className="list-decimal list-inside space-y-1 text-sm">
						<li>Safari menu → Settings for This Website</li>
						<li>Change Notifications to "Allow"</li>
						<li>Refresh the page</li>
					</ol>
				</div>
			</div>
		</Modal>
	)
}
